<template lang="pug">
div
  template(v-if="!user.logged")
    v-img(:src="require('@/assets/images/avatars/no-one.svg')")
  template(v-else)
    template(v-if="user.login === 'sisadmin'")
      v-img(:src="require('@/assets/images/avatars/sisadmin.svg')")
    template(v-else)
      v-img(:src="require('@/assets/images/avatars/default.svg')")
</template>

<script>
export default {
  props: {
    user: Object,
  },
}
</script>